import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import FailCard from "@/components/feature/FailCard";

export default function RelatedList({ currentId }: { currentId: string }) {
  const related = articles.filter((item) => item.id !== currentId).slice(0, 4);

  return (
    <section aria-labelledby="related-title" className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100 border-t border-background-200">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
        <div>
          <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600 mb-3 uppercase">
            <span className="w-6 h-px bg-primary-400"></span>
            Keep reading
          </p>
          <h2 id="related-title" className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            相关事件推荐
          </h2>
        </div>
        <Link
          to="/category"
          className="inline-flex items-center gap-1.5 h-10 px-4 rounded-md border border-background-300 text-sm text-foreground-800 whitespace-nowrap hover:border-primary-400 hover:text-primary-600 transition-colors"
        >
          浏览全部事件
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="bg-background-50 border border-background-200 rounded-lg px-4 md:px-5">
        {related.map((item) => (
          <FailCard key={item.id} {...item} variant="minimal" />
        ))}
      </div>
    </section>
  );
}